import assert from 'minimalistic-assert'
import { abTestingAtomDefinition, abTestingLoadedAtomDefinition } from './atoms/index.js'
import abTestingDefinition from './module/index.js'
import abTestingApiDefinition from './api/index.js'
import abTestingPluginDefinition from './plugins/index.js'
import abTestingAnalyticsPluginDefinition from './plugins/analytics.js'
import abTestingReportDefinition from './report/index.js'

const abTesting = ({ apiUrl = 'https://schrodinger.a.exodus.io/api' } = Object.create(null)) => {
  assert(typeof apiUrl === 'string' && apiUrl, 'expected string "apiUrl"')
  return {
    id: 'abTesting',
    definitions: [
      {
        definition: abTestingAtomDefinition,
        storage: { namespace: 'abTesting' },
        aliases: [{ implementationId: 'unsafeStorage', interfaceId: 'storage' }],
      },
      { definition: abTestingLoadedAtomDefinition },
      {
        definition: abTestingDefinition,
        config: {
          apiUrl,
        },
      },
      { definition: abTestingPluginDefinition },
      {
        if: { registered: ['analytics'] },
        definition: abTestingAnalyticsPluginDefinition,
      },
      { definition: abTestingApiDefinition },
      { definition: abTestingReportDefinition },
    ],
  }
}

export default abTesting
